import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Router} from "@angular/router";
import {Observable, Observer, throwError} from 'rxjs';
import { RestUrlsConfig } from "@signature-it/ngx-generic/config";
import { LanguageService } from "@signature-it/ngx-generic/services";
import { DictionaryTermDTO } from "@signature-it/ngx-generic/models";
import {catchError, map} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})

export class EntityService {
    protected getEntityHtmlUrl = `${this.config.appURL}/public/entity/html`;
    protected getEntityContentUrl = `${this.config.appURL}/public/entity/content`;
    protected getEntityHtmlByEntityVarUrl = `${this.config.appURL}/public/entity/html`;
    protected getEntityDataUrl = `${this.config.appURL}/public/entity`;
    protected getEntityRelatedDataUrl = `${this.config.appURL}/public/entity/related`;
    protected getEntityBreadcrumbsUrl = `${this.config.appURL}/public/entity/breadcrumbs`;
    protected getEntityTypeBodyUrl = `${this.config.appURL}/public/entity/entity_type_body/`;
    protected getDictionaryTermsUrl = `${this.config.appURL}/public/entity/dictionary_terms`;
    protected getItemVarStyleUrl = `${this.config.appURL}/public/entity/style/item_var`;
    protected getTotalContentPageUrl = `${this.config.appURL}/admin/entity/get_total_content_page`;
    protected getMediaAssetDataUrl = `${this.config.appURL}/public/entity/media_asset_data`;
    protected entityPreviewTypeVar = 'block_entity_preview';

    dictionaryTerms: Array<DictionaryTermDTO>;
    entityPreviews: any;

    constructor(
        protected http: HttpClient,
        protected config: RestUrlsConfig,
        protected router: Router,
        protected langSvc: LanguageService
    ) {}

    getEntityHtml(head: string, type_var: string): Observable<any> {
        const currLang = this.langSvc.getCurrentLanguage();
        return this.http.get(`${this.getEntityHtmlUrl}/${type_var}/${head}?lang_code=${currLang.code}`);
    }

    getEntityContent(head: string): Observable<any> {
        const currLang = this.langSvc.getCurrentLanguage();
        return this.http.get(`${this.getEntityContentUrl}/${head}?lang_code=${currLang.code}`);
    }

    getEntityHtmlByEntityVar(entityVar: string): Observable<any> {
        const currLang = this.langSvc.getCurrentLanguage();
        return this.http.get(`${this.getEntityHtmlByEntityVarUrl}/${entityVar}?lang_code=${currLang.code}`);
    }

    getEntityData(id: number): Observable<any> {
        return this.http.get(`${this.getEntityDataUrl}/${id}`);
    }

    getEntityRelatedData(params) {
        return this.http.get(`${this.getEntityRelatedDataUrl}`, {
            params: { ...params }
        });
    }

    getEntityBreadcrumbs(params): Observable<any> {
        return this.http.get(`${this.getEntityBreadcrumbsUrl}`, {
            params: { ...params }
        });
    }

    getEntityTypeBody(entityType): Observable<any> {
        return this.http.get(`${this.getEntityTypeBodyUrl}/${entityType}`);
    }

    getEntityPreviews() {
        return new Observable((observer: Observer<any>) => {
            if (this.entityPreviews) {
                observer.next(this.entityPreviews);
                observer.complete();
                return;
            }
            this.getEntityTypeBody(this.entityPreviewTypeVar).subscribe(res => {
                this.entityPreviews = res;
                observer.next(res);
                observer.complete();
            })
        });
    }

    getDictionaryTerms() {
        return new Observable((observer: Observer<any>) => {
            if (this.dictionaryTerms) {
                observer.next(this.dictionaryTerms);
                observer.complete();
                return;
            }
            this.getDictionaryTermsAPI().subscribe(res => {
                this.dictionaryTerms = res;
                observer.next(res);
                observer.complete();
            })
        });
    }

    getDictionaryTermsAPI() {
        return this.http.get(`${this.getDictionaryTermsUrl}`)
            .pipe(map((res: any) => DictionaryTermDTO.createFromArray(res)),
                catchError( (error: any) => throwError(error)));
    }

    getStyleByItemVar(itemVar: string): Observable<string> {
        return this.http.get<string>(`${this.getItemVarStyleUrl}/${itemVar}`);
    }

    getTotalContentPage(distributionChannelIds): Observable<string> {
        return this.http.get<string>(`${this.getTotalContentPageUrl}?distribution_channel_list=${distributionChannelIds.join()}`);

    }

    getMediaAssetData(itemId): Observable<any> {
        return this.http.get<string>(`${this.getMediaAssetDataUrl}/${itemId}`);
    }

    callApi(api): Observable<any>{
        return this.http.get<string>(`${this.config.appURL}/${api}`);
    }
}
